import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.03 8.97a.75.75 0 0 1 0 1.06l-5 5a.75.75 0 1 1-1.06-1.06l5-5a.75.75 0 0 1 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.47 4.014a6.022 6.022 0 1 1 8.516 8.516l-2.61 2.61a.75.75 0 1 1-1.06-1.06l2.61-2.61a4.522 4.522 0 1 0-6.396-6.396l-2.61 2.61a.75.75 0 0 1-1.06-1.06zM7.684 8.86a.75.75 0 0 1 0 1.06l-2.61 2.61a4.522 4.522 0 1 0 6.396 6.396l2.61-2.61a.75.75 0 0 1 1.06 1.06l-2.61 2.61a6.022 6.022 0 1 1-8.516-8.516l2.61-2.61a.75.75 0 0 1 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }